<ng-content></ng-content>
<div
  [ngStyle]="{
    overflow: zTableModel.options?.virtualScroll && 'hidden'
  }"
  class="m-ui-table"
>
  <ui-base-table
    [theme]="theme"
    [zTableModel]="zTableModel"
    [cellSize]="cellSize"
    [cellTextAlign]="cellTextAlign"
    [showClickOnPlusMsg]="showClickOnPlusMsg"
    [omitEmptyTableTemplate]="omitEmptyTableTemplate"
    [emptyTableText]="emptyTableText"
    (onRowAction)="actionCell($event)"
    (onSelectRow)="selectedRows($event)"
    (onSelectAllToggled)="selectAllToggled($event)"
    (onResetRow)="resetRow($event)"
    (onTableChange)="tableChange($event)"
    (onRowEditSave)="rowEditSave($event)"
    (onRowAddSave)="rowAddSave($event)"
    (onRowDelete)="rowDelete($event)"
    (onActionListItemSelection)="actionListItemSelection($event)"
    (onMultiEdit)="multiEdit($event)"
    (onButtonCLick)="onButtonClick($event)"
    (onToggleChangeEmitter)="onToggleChange($event)"
    (onLabelledToggleChangeEmitter)="onLabelledToggleChange($event)"
    (onExternalEditableInputClicked)="onExternalEditableInputClicked($event)"
    (onLinkClicked)="onLinkClick($event)"
  ></ui-base-table>
</div>
